import "./VideoSection.css";
import CallToActionBlock from "../../../components/callToActionBlock/CallToActionBlock";
import LazyLoadYoutube from "../../../components/lazyLoadYoutube/LazyLoadYoutube";
import { useTranslation } from "react-i18next";

function VideoSection() {
  const { t } = useTranslation();

  const callToActionBlockStyles = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  };

  return (
    <section className="video-wrapper" aria-labelledby="video-section-title">
      <div className="video-wrapper__inner">
        <div className="video-wrapper__heading">
          <div>
            <span className="video-wrapper__eyebrow">ACTIVE GENERATION</span>
            <h2 id="video-section-title" className="video-wrapper__title">
              {t("videoSection.title")}
            </h2>
          </div>
          <p className="video-wrapper__description">
            {t("videoSection.description")}
          </p>
        </div>

        <div className="video-wrapper__box">
          <div className="video-wrapper__video-frame">
            <div className="video-wrapper__video-container">
              <LazyLoadYoutube videoId="8LS8ozKLGpM" />
            </div>
          </div>

          <div className="video-wrapper__call-to-action">
            <CallToActionBlock
              attachmentBlock="VideoBlock"
              blockStyles={callToActionBlockStyles}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default VideoSection;
